import { useState, useEffect } from "react";
import {
  Frame,
  Loading,
  Header,
  Input,
  Select,
  ValidaUid,
} from "../components";
import { useNavigate } from "react-router-dom";
import { ValidaForm1 } from "../components/Validacao";
import { db, auth } from "../config/firebase";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { Row, Col } from "react-bootstrap";

const Form1 = () => {
  const [dados, setDados] = useState({
    nome: "",
    vinculo: "",
    cpf: "",
    rg: "",
    fone1: "",
    fone2: "",
    logradouro: "",
    endereco: "",
    numero: "",
    bairro: "",
    cidade: "",
    cep: "",
  });
  const [erro, setErro] = useState({});
  const [loading, setLoading] = useState(true);

  let uid = auth.currentUser?.uid;

  const navigate = useNavigate();

  function handleChange(e) {
    const { name, value } = e.target;

    let novoValor = value;

    //SOMENTE LETRAS
    if (["nome", "cidade"].includes(name)) {
      novoValor = value.replace(/[^a-zA-ZÀ-ÿ\s]/g, "");
    }

    //SOMENTE NUMEROS
    if (["cpf", "fone1", "fone2", "cep"].includes(name)) {
      novoValor = value.replace(/\D/g, "");
    }

    //LETRAS E NUMEROS
    if (["rg"].includes(name)) {
      novoValor = value.replace(/[^a-zA-Z0-9]/g, "");
    }

    setDados((prev) => ({
      ...prev,
      [name]: novoValor.toUpperCase(),
    }));
  }

  const setData = async () => {
    const email = auth?.currentUser?.email;

    await setDoc(
      doc(db, "desconto2026", uid),
      { ...dados, email: email, uid: uid },
      { merge: true }
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setLoading(true);

    const err = ValidaForm1(dados);

    if (err) {
      setErro(err);
      setLoading(false);
    } else {
      setData().then(() => navigate("../form2"));
    }
  };

  const buscaDados = async () => {
    const uid = await ValidaUid();

    if (uid) {
      const qry = await getDoc(doc(db, "desconto2026", uid));

      const data = qry.data();

      if (!data?.status) {
        setLoading(false);
      } else if (data?.status === "e") {
        setLoading(false);
        setDados(data);
      } else {
        navigate("../home");
      }
    }
  };

  useEffect(() => {
    buscaDados();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {loading && <Loading />}
      <Header nome={dados?.nome} foto={dados?.urlFoto} />
      {!loading && (
        <Frame
          body={
            <form
              className="text-start"
              autoComplete="off"
              onSubmit={handleSubmit}
              noValidate
            >
              <Row>
                <Col className="mt-3" sm="9">
                  <Input
                    id="nome"
                    label="Nome Completo"
                    type="text"
                    className={erro.nome && "is-invalid"}
                    placeholder="Conforme seu documento"
                    value={dados.nome}
                    onChange={handleChange}
                    erro={erro.nome}
                    autoFocus
                  />
                </Col>
                <Col className="mt-3" sm="3">
                  <Select
                    id="vinculo"
                    label="Vínculo"
                    onChange={handleChange}
                    size="col-sm-4"
                    value={dados.vinculo}
                    erro={erro.vinculo}
                    options={
                      <>
                        <option value="">Selecione</option>
                        <option value="ESTUDANTE">Estudante</option>
                        <option value="PROFESSOR">Professor</option>
                      </>
                    }
                  />
                </Col>
              </Row>
              <Row>
                <Col className="mt-3" sm="3">
                  <Input
                    id="cpf"
                    label="CPF"
                    type="text"
                    className={erro.cpf && "is-invalid"}
                    placeholder="Digite seu CPF"
                    value={dados.cpf}
                    onChange={handleChange}
                    erro={erro.cpf}
                  />
                </Col>
                <Col className="mt-3" sm="3">
                  <Input
                    id="rg"
                    label="RG"
                    type="text"
                    className={erro.rg && "is-invalid"}
                    placeholder="Digite seu RG"
                    value={dados.rg}
                    onChange={handleChange}
                    erro={erro.rg}
                  />
                </Col>
                <Col className="mt-3" sm="3">
                  <Input
                    id="fone1"
                    label="Fone 1"
                    type="text"
                    className={erro.fone1 && "is-invalid"}
                    placeholder="DDD + número"
                    value={dados.fone1}
                    onChange={handleChange}
                    erro={erro.fone1}
                  />
                </Col>
                <Col className="mt-3" sm="3">
                  <Input
                    id="fone2"
                    label="Fone 2"
                    type="text"
                    className={erro.fone2 && "is-invalid"}
                    placeholder="Opcional"
                    value={dados.fone2}
                    onChange={handleChange}
                    erro={erro.fone2}
                  />
                </Col>
              </Row>
              <Row>
                <Col className="mt-3" sm="3">
                  <Select
                    id="logradouro"
                    label="Logradouro"
                    onChange={handleChange}
                    size="col-sm-4"
                    value={dados.logradouro}
                    erro={erro.logradouro}
                    options={
                      <>
                        <option value="">Selecione</option>
                        <option value="RUA">Rua</option>
                        <option value="AVENIDA">Avenida</option>
                        <option value="TRAVESSA">Travessa</option>
                        <option value="PRAÇA">Praça</option>
                        <option value="PARQUE">Parque</option>
                        <option value="CONDOMÍNIO">Condomínio</option>
                        <option value="ALAMEDA">Alameda</option>
                        <option value="ESTRADA">Estrada</option>
                        <option value="BECO">Beco</option>
                        <option value="VIELA">Viela</option>
                        <option value="LARGO">Largo</option>
                      </>
                    }
                  />
                </Col>
                <Col className="mt-3" sm="9">
                  <Input
                    id="endereco"
                    label="Endereço"
                    type="text"
                    className={erro.endereco && "is-invalid"}
                    placeholder="Digite seu endereço"
                    value={dados.endereco}
                    onChange={handleChange}
                    erro={erro.endereco}
                  />
                </Col>
              </Row>
              <Row>
                <Col className="mt-3" sm="3">
                  <Input
                    id="numero"
                    label="Número"
                    type="text"
                    className={erro.numero && "is-invalid"}
                    placeholder="9999"
                    value={dados.numero}
                    onChange={handleChange}
                    erro={erro.numero}
                  />
                </Col>
                <Col className="mt-3" sm="3">
                  <Input
                    id="bairro"
                    label="Bairro"
                    type="text"
                    className={erro.bairro && "is-invalid"}
                    placeholder="Digite seu bairro"
                    value={dados.bairro}
                    onChange={handleChange}
                    erro={erro.bairro}
                  />
                </Col>
                <Col className="mt-3" sm="3">
                  <Input
                    id="cidade"
                    label="Cidade"
                    type="text"
                    className={erro.cidade && "is-invalid"}
                    placeholder="Digite sua cidade"
                    value={dados.cidade}
                    onChange={handleChange}
                    erro={erro.cidade}
                  />
                </Col>
                <Col className="mt-3" sm="3">
                  <Input
                    id="cep"
                    label="CEP"
                    type="number"
                    className={erro.cep && "is-invalid"}
                    placeholder="Digite seu CEP"
                    value={dados.cep}
                    onChange={handleChange}
                    erro={erro.cep}
                  />
                </Col>
              </Row>

              <Row>
                <Col className="mt-4 d-grid" sm="12">
                  <button type="submit" className="btn btn-primary">
                    PRÓXIMO
                  </button>
                </Col>
              </Row>
            </form>
          }
          title="Dados Cadastrais"
        />
      )}
    </>
  );
};

export default Form1;
